import { Pipe, PipeTransform, Inject } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'packageTotalValue'
})
export class PackageTotalValuePipe implements PipeTransform {

  constructor(
    @Inject('splitService') private splitService
  ) {}

  transform(packageList: any[], enableUnitDisplay?: boolean): string {
    let totalValue = 0;
    const currencyCode = this.splitService.getCurrencyCode();
    const isPackageTotalValue = this.splitService.isOmsPackageTotalValue();

    if (Array.isArray(packageList) && packageList.length) {
      packageList.forEach(pkg => {
        if (pkg?.items?.length) {
          totalValue += pkg.items.reduce((res, item) => {
            if (item.value) {
              res += (isPackageTotalValue ? item.value : (item.value * (item.count || 1)));
            }
            return res;
          }, 0);
        }
      });
    }

    const displayValue = totalValue.toLocaleString(undefined, { maximumFractionDigits: 2 });
    return `${displayValue} ${enableUnitDisplay ? currencyCode : ''}`.trim();
  }
}





// import { Pipe, PipeTransform, Inject } from '@angular/core';
//
// @Pipe({
//     name: 'packageTotalValue'
// })
// export class PackageTotalValuePipe implements PipeTransform {
//
//     constructor(
//         @Inject('splitService') private splitService
//     ) {}
//
//     transform(packageRef: any, enableUnitDisplay?: boolean): string {
//         let packagesTotalValue = 0;
//         const currencyCode = this.splitService.getCurrencyCode();
//         const isPackageTotalValue = this.splitService.isOmsPackageTotalValue();
//
//         if (packageRef && packageRef.items?.length) {
//             packagesTotalValue = packageRef.items.reduce((res, item) => {
//                 if (item.value) {
//                     res += (isPackageTotalValue ? item.value : (item.value * (item.count || 1)));
//                 }
//                 return res;
//             }, 0);
//         }
//
//         const displayValue = packagesTotalValue.toLocaleString(undefined, { maximumFractionDigits: 2 });
//         return `${displayValue} ${enableUnitDisplay ? currencyCode : ''}`;
//     }
// }
